
import Request from '@scripts/request.js';


/**
 * A front-end companion to the `SBM\Ajax\Base` class implementation. This code
 * is written to handle the data in the way that the PHP side-of-things is
 * going to return it.
 */
class Ajax {
  constructor(ajaxUrl) {
    this.ajaxUrl = ajaxUrl;

    this.fetchComplete = this.fetchComplete.bind(this);
  }

  buildUrl(action, data) {
    var result = Request.updateQueryStringParameter(this.ajaxUrl, 'action', action);

    if (data) {
      if (typeof data == 'object') {
        for (var key in data) {
          if (data.hasOwnProperty(key)) {
            result = Request.updateQueryStringParameter(result, key, data[key]);
          }
        }
      } else {
        result = result + '&' + data;
      }
    }


    return result;
  }

  /**
   * make a request for the given action, optionally passing additional query
   * parameters.
   * @param {string} action - The name of the WP Ajax Action
   * @param {object} data - (optional) An object containing key-value pairs to
   *   be added to the reulting request.
   */
  fetch(action, data) {
    var fetch = window.fetch;
    var requestUrl = this.buildUrl(action, data);
    var request = new window.Request(requestUrl);

    return fetch(request)
      .then(function(response) {
        if (response.status === 200) {
          return response.json();
        }
      })
      .then(this.fetchComplete);
  }

  fetchComplete(response) {
    var result = null;

    if (response) {
      if (response.error) {
        throw response.message;
      } else {
        if (response.data) {
          result = response.data;
        }
      }
    }


    return result;
  }

  post(action, data) {
    var that = this;

    return new Promise(function(resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', that.ajaxUrl);
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      xhr.onreadystatechange = function() {
        if (this.readyState != 4) {
          return;
        }

        if (this.status == 200) {
          var data = JSON.parse(this.responseText);
          resolve(data);
        } else {
          reject('API call has failed...');
        }
      };

      var postData = 'action=' + encodeURIComponent(action) + '&' + data;

      xhr.send(postData);
    });
  }
}

var AjaxService = new Ajax(window.SBM.ajaxUrl);


export default AjaxService;

export { AjaxService };

